
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import StoryEditor from "./StoryEditor";

interface StoryEditorDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  editingStory: any | null;
  onSave: (story: any) => void;
}

const StoryEditorDialog: React.FC<StoryEditorDialogProps> = ({
  isOpen,
  onOpenChange,
  editingStory,
  onSave,
}) => {
  const { language } = useLanguage();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-screen overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {editingStory?.title_en
              ? language === "en" ? "Edit Story" : "تحرير القصة"
              : language === "en" ? "Add New Story" : "إضافة قصة جديدة"
            }
          </DialogTitle>
          <DialogDescription>
            {language === "en" 
              ? "Edit the details of this story in both English and Arabic" 
              : "تحرير تفاصيل هذه القصة باللغتين الإنجليزية والعربية"
            }
          </DialogDescription>
        </DialogHeader>
        
        {editingStory && (
          <StoryEditor 
            story={editingStory}
            onSave={onSave}
            onCancel={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StoryEditorDialog;
